import { StackProjections } from './stack-projections.js';
import { freeSpaceLeft, freeSpaceRight, isAtTheEdge, isAtTheLeftEdge, isAtTheRightEdge, isItemSnappedFromLeft, isItemSnappedFromRight } from './stack.js';
export const StackExpressions = {
    $isStackItemSnapped: (self, state, ctx)=>{
        const stackProjections = new StackProjections(ctx.componentReader);
        const stackItem = stackProjections.getStackItem(self.id, state);
        const stack = stackProjections.getStack(stackItem.stackKey, state);
        if (!stack) {
            throw new Error(`Stack ${stackItem.stackKey} not found, cannot validate stack! Make sure the stack exists and has a valid stackId.`);
        }
        return isItemSnappedFromLeft(self.id, stack) || isItemSnappedFromRight(self.id, stack);
    },
    $isStackItemSnappedLeft: (self, state, ctx)=>{
        const stackProjections = new StackProjections(ctx.componentReader);
        const stackItem = stackProjections.getStackItem(self.id, state);
        const stack = stackProjections.getStack(stackItem.stackKey, state);
        if (!stack) {
            throw new Error(`Stack ${stackItem.stackKey} not found, cannot validate stack! Make sure the stack exists and has a valid stackId.`);
        }
        return isItemSnappedFromLeft(self.id, stack);
    },
    $isStackItemSnappedRight: (self, state, ctx)=>{
        const stackProjections = new StackProjections(ctx.componentReader);
        const stackItem = stackProjections.getStackItem(self.id, state);
        const stack = stackProjections.getStack(stackItem.stackKey, state);
        if (!stack) {
            throw new Error(`Stack ${stackItem.stackKey} not found, cannot validate stack! Make sure the stack exists and has a valid stackId.`);
        }
        return isItemSnappedFromRight(self.id, stack);
    },
    $isStackItemAtTheLeftEdge: (self, state, ctx)=>{
        const stackProjections = new StackProjections(ctx.componentReader);
        const stackItem = stackProjections.getStackItem(self.id, state);
        const stack = stackProjections.getStack(stackItem.stackKey, state);
        if (!stack) {
            throw new Error(`Stack ${stackItem.stackKey} not found, cannot validate stack! Make sure the stack exists and has a valid stackId.`);
        }
        return isAtTheLeftEdge(self.id, stack);
    },
    $isStackItemAtTheRightEdge: (self, state, ctx)=>{
        const stackProjections = new StackProjections(ctx.componentReader);
        const stackItem = stackProjections.getStackItem(self.id, state);
        const stack = stackProjections.getStack(stackItem.stackKey, state);
        if (!stack) {
            throw new Error(`Stack ${stackItem.stackKey} not found, cannot validate stack! Make sure the stack exists and has a valid stackId.`);
        }
        return isAtTheRightEdge(self.id, stack);
    },
    $isStackItemAtTheEdge: (self, state, ctx)=>{
        const stackProjections = new StackProjections(ctx.componentReader);
        const stackItem = stackProjections.getStackItem(self.id, state);
        const stack = stackProjections.getStack(stackItem.stackKey, state);
        if (!stack) {
            throw new Error(`Stack ${stackItem.stackKey} not found, cannot validate stack! Make sure the stack exists and has a valid stackId.`);
        }
        return isAtTheEdge(self.id, stack);
    },
    $freeSpaceLeft: (self, state, ctx)=>{
        const stackProjections = new StackProjections(ctx.componentReader);
        const stackItem = stackProjections.getStackItem(self.id, state);
        const stack = stackProjections.getStack(stackItem.stackKey, state);
        if (!stack) {
            throw new Error(`Stack ${stackItem.stackKey} not found, cannot validate stack! Make sure the stack exists and has a valid stackId.`);
        }
        return freeSpaceLeft(self.id, stack);
    },
    $freeSpaceRight: (self, state, ctx)=>{
        const stackProjections = new StackProjections(ctx.componentReader);
        const stackItem = stackProjections.getStackItem(self.id, state);
        const stack = stackProjections.getStack(stackItem.stackKey, state);
        if (!stack) {
            throw new Error(`Stack ${stackItem.stackKey} not found, cannot validate stack! Make sure the stack exists and has a valid stackId.`);
        }
        return freeSpaceRight(self.id, stack);
    }
};

//# sourceMappingURL=stack-expressions.js.map